// src/Math/StaticPlot.js
import React, { useRef, useEffect } from "react";
import drawGrid from "./drawGrid";

/**
 * Renders a simple coordinate grid and plots whatever points you pass in.
 */
export default function StaticPlot({
  widthCells = 10,
  heightCells = 10,
  cellSize = 30,
  points = []
}) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    drawGrid(canvasRef.current, { widthCells, heightCells, cellSize }, points);
  }, [points, widthCells, heightCells, cellSize]);

  return (
    <canvas
      ref={canvasRef}
      width={widthCells * cellSize}
      height={heightCells * cellSize}
      style={{ border: "1px solid #444" }}
    />
  );
}
